<template>
  <div class="card border-0 bg-transparent pick-referring-office h-100">
    <div
      v-if="title"
      class="card-header view-header d-flex justify-content-between align-items-center"
      style="background: var(--border-color); display: flex; padding: 1rem 2rem; min-height: 85px"
    >
      <card-header :title="title || 'Create referral'" :hideBack="true" style="">
        <router-link
          v-if="redirect == 'referral'"
          class="ml-auto btn btn-lg btn-primary font-weight-bold mx-auto pulse"
          to="/referral/?to=1"
          >Send a test referral</router-link
        >
      </card-header>
    </div>
    <div
      class="card-body px-5 overflow-auto d-flex"
      :style="isInModal ? '' : 'margin-bottom:70px'"
      data-v-tour="selectSpecialty"
    >
      <div class="d-flex flex-column flex-grow-1">
        <!-- <h3 class="mb-3">{{ subtitle }}</h3> -->
        <div v-if="isSpecialistTabsVisible" class="row specialties">
          <div class="col-12 col-md-4 col-lg-3 mb-2" v-for="s in specialtyList" :key="s.i">
            <div class>
              <a
                href="javascript:void(0)"
                class="specialty-card d-block border rounded"
                :class="{ active: specialtyTab === s.i }"
                @click="filterSpecialty(s.i)"
                :data-v-tour="`selectSpecialty${s.name}`"
              >
                {{ s.name }}
                <!-- <small class="text-hint" v-if="s.count">({{s.count}})</small> -->
                <!-- <small class="d-block text-hint" style="font-size:10px">Select</small> -->
                <!-- <small v-if="s.count" class="d-block text-hint" style="font-size:10px">
                  Quick Select
                  <span class="text-capitalize">{{s.items[0].name.toLowerCase()}}</span>
                </small>-->
              </a>
            </div>
          </div>
        </div>
        <div class="flex-grow-1 d-flex flex-column" :class="{ 'z-index-for-tour': isTourFixAppliedToTable }">
          <template v-if="isShowingListOnLoad">
            <div class="mb-2">
              <div class="tab-style font-size-1 d-flex pb-0">
                <div class="flex-grow-1 d-flex align-items-end">
                  <a
                    href="javascript:void(0)"
                    @click="
                      isMyNetworkOnly = true
                      searchTab = null
                    "
                    class="tab-style-item"
                    :class="{ active: !searchTab && isMyNetworkOnly }"
                    >Favorites</a
                  >
                  <a
                    href="javascript:void(0)"
                    @click="
                      isMyNetworkOnly = false
                      searchTab = null
                    "
                    class="tab-style-item"
                    :class="{ active: !searchTab && !isMyNetworkOnly }"
                    >Nearby
                    {{ specialtyTab == null ? 'practices' : PracticeTypesPlural[specialtyTab].toLowerCase() }}</a
                  >
                  <a
                    v-if="term"
                    href="javascript:void(0)"
                    @click="showSearch"
                    :class="{ active: searchTab }"
                    class="tab-style-item"
                    >Search results

                    <font-awesome-icon icon="spinner-third" class="text-primary ml-2" spin v-if="isSearching" />
                    <span v-else class="badge badge-pill badge-light ml-2 font-weight-bold"
                      >{{ Math.min(99, searchResultsCount) }}<span v-if="searchResultsCount > 99">+</span></span
                    >
                  </a>
                </div>
                <div class="" style="min-width: 340px">
                  <div class="input-group input-group-lg search-input" :class="{ active: !!term }">
                    <input
                      type="text"
                      v-model.trim="networkTerm"
                      class="form-control borderless px-2 text-right"
                      placeholder="Find a practice/doctor by phone or keyword"
                      @keyup.enter="searchNetwork"
                      data-v-tour="networkSearch"
                    />
                    <div class="input-group-append">
                      <button @click="searchNetwork" class="btn btn-link px-2" :disabled="isSearching">
                        <font-awesome-icon icon="spinner-third" spin v-if="isSearching" />
                        <font-awesome-icon v-else :icon="['far', 'search']" class="text-body" />
                      </button>
                    </div>
                  </div>
                </div>
                <div class="align-self-center more-options">
                  <div class="dropdown">
                    <button
                      class="btn btn-link btn-lg px-2"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <font-awesome-icon :icon="['far', 'ellipsis-h']" class="text-body" />
                    </button>
                    <div class="dropdown-menu">
                      <a
                        href="javascript:void(0)"
                        @click.prevent="isAddPracticeModalVisible = true"
                        class="dropdown-item align-items-center"
                      >
                        <font-awesome-icon :icon="['far', 'user-plus']" class="mr-2" />
                        Add practice
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center justify-space-between mb-2">
              <div v-if="redirect == 'op-report'" class="specialty-select d-flex align-items-center mr-3 flex-grow-1">
                <span class="text-muted">Specialty:</span>

                <div class="d-inline-flex specialty-filter-inline _tab-style p-0">
                  <a
                    href="javascript:void(0)"
                    class="btn btn-link _tab-style-item"
                    :class="{ active: specialtyTab == null }"
                    @click="filterSpecialty()"
                    >All</a
                  >

                  <a
                    href="javascript:void(0)"
                    class="btn btn-link _tab-style-item"
                    v-for="s in suggestedSpecialties.map((a) => ({ i: a, name: PracticeTypes[a] }))"
                    :class="{ active: specialtyTab === s.i }"
                    @click="filterSpecialty(s.i)"
                    :key="s.i"
                    >{{ s.name }}
                  </a>
                </div>
                <div class="dropdown">
                  <button
                    class="btn btn-link px-2 py-1 dropdown-toggle dropdown-toogle-no-icon"
                    :class="
                      specialtyTab && !suggestedSpecialties.includes(specialtyTab)
                        ? 'text-primary font-weight-bolder active'
                        : 'text-body'
                    "
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    {{ specialtyTab && !suggestedSpecialties.includes(specialtyTab) ? selectedSpecialty : 'Other' }}
                    <font-awesome-icon :icon="['far', 'angle-down']" class="ml-1" />
                  </button>
                  <div class="dropdown-menu">
                    <a
                      href="javascript:void(0)"
                      class="dropdown-item"
                      v-for="s in specialtyList.filter((s) => !suggestedSpecialties.includes(s.i))"
                      :class="{ active: specialtyTab === s.i }"
                      @click="filterSpecialty(s.i)"
                      :key="s.i"
                      >{{ s.name }}
                    </a>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end ml-auto">
                <div class="sort-select d-flex align-items-center mr-3" v-if="isMyNetworkOnly">
                  <span class="text-muted">Sort by:</span>
                  <div class="dropdown">
                    <button
                      class="btn btn-link px-1 dropdown-toggle dropdown-toogle-no-icon text-body font-weight-bolder"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      {{ sort }}
                      <font-awesome-icon :icon="['far', 'angle-down']" class="ml-1" />
                    </button>
                    <div class="dropdown-menu">
                      <a
                        class="dropdown-item"
                        href="javascript:void(0)"
                        v-for="s in ['Last referral sent', 'Distance', 'Name']"
                        :key="s"
                        :class="{ active: s == sort }"
                        @click="sort = s"
                        >{{ s }}</a
                      >
                    </div>
                  </div>
                </div>
                <div class="distance-select d-flex align-items-center">
                  <span class="text-muted">Distance:</span>
                  <div class="dropdown">
                    <button
                      class="btn btn-link px-1 dropdown-toggle dropdown-toogle-no-icon text-body font-weight-bolder"
                      type="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      {{ miles != 'Any' ? `within ${miles}mi` : 'Any' }}
                      <font-awesome-icon :icon="['far', 'angle-down']" class="ml-1" />
                    </button>
                    <div class="dropdown-menu">
                      <a
                        class="dropdown-item"
                        href="javascript:void(0)"
                        v-for="m in [5, 10, 30, 50, 100, 500, 'Any']"
                        :key="m"
                        :class="{ active: m == miles }"
                        @click="miles = m"
                        >{{ m != 'Any' ? `within ${m}mi` : 'Any' }}</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isEmpty && !isSearching && searchTab != null" class="pt-3 text-center">
              <span style="font-size: 1.5em">
                No results found
                <span v-if="searchedTerm">
                  for
                  <b>{{ searchedTerm }}</b>
                </span>
                <span v-if="specialtyTab != null">within {{ PracticeTypes[specialtyTab].toLowerCase() }}</span>
              </span>
              <br />
              <small>
                Tip: Try extending your radius or, if you can't find them then you can
                <a href="javascript:void(0)" @click.prevent="isAddPracticeModalVisible = true"
                  >manually add a practice</a
                >
              </small>
            </div>
            <placeholders v-if="isLoading" :rounded="true">
              <placeholders-text :lines="3" class="fixed" height="5rem" />
            </placeholders>
            <!-- todo: pluralize specialist -->
            <div
              v-else-if="
                searchTab == null &&
                !isSuggestedLoading &&
                (filteredOrResults.length === 0 || (isMyNetworkOnly && !network.length))
              "
              class="text-center m-auto flex-grow-1 align-items-center d-flex flex-column"
            >
              <div class="align-self-center my-auto">
                <span v-if="!network.length">
                  <h5 class="text-hint font-weight-bold">Your favorites are empty</h5>
                  Use the search to find the practice or doctor.
                </span>
                <span style="font-size: 1.5em" v-else-if="searchTab == null && filteredOrResults.length === 0">
                  {{ isMyNetworkOnly ? "You don't have any favorite " : 'There are no suggested ' }}
                  {{ specialtyTab == null ? 'practices' : PracticeTypesPlural[specialtyTab].toLowerCase() }}
                  yet.</span
                >
                <br />
                <a
                  v-if="isNearbyAvailable"
                  class="btn btn-lg btn-outline-primary d-inline-block mt-3"
                  href="javascript:void(0)"
                  @click="isMyNetworkOnly = false"
                  >View nearby
                  {{ specialtyTab == null ? 'practices' : PracticeTypesPlural[specialtyTab].toLowerCase() }}</a
                ><a
                  v-else
                  class="btn btn-lg btn-outline-primary d-inline-block mt-3"
                  href="javascript:void(0)"
                  @click="isAddPracticeModalVisible = true"
                  >Add practice</a
                >
                <br />
                <span class="text-muted d-inline-block mt-2" style="font-size: 0.775rem"
                  ><b>Tip:</b> You can also search for an practice by name or phone number</span
                >
              </div>
            </div>
          </template>
          <div
            v-if="isSearching || pagedResults.length || (isSuggestedLoading && numSuggestionsVisible > 0)"
            class="d-flex flex-column flex-grow-1"
          >
            <placeholders v-if="isSearching" :rounded="true">
              <placeholders-text :lines="3" class="fixed" height="5rem" />
            </placeholders>

            <table v-else-if="pagedResults.length" class="table table-sm table-hover">
              <tbody data-v-tour="networkResults">
                <!-- <tr v-if="network.length === 0" class="hover-none">
                    <td class="text-hint text-center p-3">
                      <h4 class="text-info mb-0" style="line-height:1em">Woo! Your first referral</h4>Use the search below to find your first referring practice.
                    </td>
                  </tr>-->
                <template v-for="(item, i) in pagedResults">
                  <tr v-if="i > 0" class="spacer" :key="`${item.id}${item.isSuggested}${item.is_in_network}spacer`">
                    <td colspan="42"></td>
                  </tr>
                  <suggested-row
                    class="suggested-row"
                    :key="`${item.id}${item.isSuggested}`"
                    :item="item"
                    :redirect="redirect"
                    :isSpecialtyVisible="specialtyTab == null"
                    @selected="selectedPractice"
                    :isSelected="preselected.includes(item.id)"
                  />
                </template>
              </tbody>
            </table>
            <template
              v-if="
                !isInModal &&
                isMyNetworkOnly &&
                isNearbyAvailable &&
                pagedResults.length < 5 &&
                highlightSuggested.length
              "
            >
              <h5 class="mt-3 mb-4">
                We think you may know...
                <!-- <small><a href="#" @click="isMyNetworkOnly = false">see more</a></small> -->
              </h5>
              <table class="table table-sm table-hover">
                <tbody>
                  <!-- <tr v-if="network.length === 0" class="hover-none">
                    <td class="text-hint text-center p-3">
                      <h4 class="text-info mb-0" style="line-height:1em">Woo! Your first referral</h4>Use the search below to find your first referring practice.
                    </td>
                  </tr>-->
                  <template v-for="(item, i) in highlightSuggested">
                    <tr v-if="i > 0" class="spacer" :key="`${item.id}${item.doctor_id}${item.isSuggested}spacer`">
                      <td colspan="42"></td>
                    </tr>
                    <suggested-row
                      class="suggested-row"
                      :key="`${item.id}${item.isSuggested}`"
                      :item="item"
                      :redirect="false"
                      :isSpecialtyVisible="specialtyTab == null"
                      @selected="addSelectionToNetwork"
                      :isSelected="preselected.includes(item.id)"
                      :addToNetworkBtnText="`Favorite`"
                    />
                  </template>
                </tbody>
              </table>
            </template>
            <placeholders v-if="isSuggestedLoading && numSuggestionsVisible > 0" :rounded="true">
              <placeholders-text :lines="Math.min(5, limit - pagedResults.length)" class="fixed" height="5rem" />
            </placeholders>
          </div>
          <div class="row" v-if="pageCount > 1">
            <div class="col">
              <nav aria-label="Network paging navigation" style="position: static; float: right">
                <paginate
                  :page-count="pageCount"
                  :value="page"
                  :container-class="'pagination'"
                  :page-class="'page-item'"
                  :page-link-class="'page-link'"
                  :next-class="'page-item'"
                  :next-link-class="'page-link'"
                  :prev-class="'page-item'"
                  :prev-link-class="'page-link'"
                  :click-handler="changePage"
                  class="mb-1"
                >
                  <template v-slot:prev>
                    <font-awesome-icon :icon="['far', 'angle-left']" class="" />
                  </template>
                  <template v-slot:next>
                    <font-awesome-icon :icon="['far', 'angle-right']" class="" />
                  </template>
                </paginate>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-bar flex-column" v-if="showAdd">
      <div class="d-flex justify-content-center align-items-center mb-3">
        <h5 class="mb-0 mr-3">Can't find the practice you're looking for?</h5>
        <a href="" class="btn btn-lg px-5 btn-primary" @click.prevent="isAddPracticeModalVisible = true">
          <font-awesome-icon :icon="['far', 'plus']" class="mr-2" />Add practice
        </a>
      </div>
    </div>
    <add-practice
      @selected="manuallySelected"
      :show="isAddPracticeModalVisible"
      @close="isAddPracticeModalVisible = false"
    />
  </div>
</template>
<script>
import Modal from '@/components/Modal'
import NpiService from '@/services/NpiService'
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
import posthog from 'posthog-js'
import SuggestedRow from '../../components/network/SuggestedRow.vue'
import AddPractice from '../../components/add-practice/AddPracticeModal.vue'

export default {
  components: {
    Modal,
    SuggestedRow,
    AddPractice,
  },
  props: {
    redirect: {
      type: String,
      default: 'referral',
    },
    title: {
      type: String,
      default: 'Create referral',
    },
    subtitle: {
      type: String,
      default: 'Who are you referring to?',
    },
    default: {
      type: Number,
      required: false,
      default: null,
    },
    preselected: {
      type: Array,
      default: () => [],
    },
    showAdd: {
      type: Boolean,
      default: true,
    },
    isInModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMyNetworkOnly: true,
      isFilteringZip: true,
      isInitialHelpShown: true,
      isSearching: false,
      isEmpty: false,
      isError: false,
      isSelectingPractice: false,
      term: '',
      networkTerm: '',
      searchedTerm: '',
      results: [],
      page: 1,
      searchTimeout: null,
      specialtyTab: this.default,
      searchTab: null,
      searchResultsCount: null,
      isShowingListOnLoad: true,
      miles: 30,
      sort: 'Last referral sent',
      isAddPracticeModalVisible: false,
      isSpecialistTabsVisible: false,
    }
  },
  async mounted() {
    try {
      this.isSpecialistTabsVisible = posthog.isFeatureEnabled('specialist-tabs-visible', {
        send_event: false,
      })
    } catch {}
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('users', ['users']),
    ...mapState('practices', ['isLoading']),
    ...mapState('suggested', {
      suggested: 'suggested',
      isSuggestedLoading: 'isLoading',
    }),
    ...mapState('tour', ['activeTour']),
    ...mapGetters('suggested', ['withNetwork']),
    ...mapGetters('practices', ['network']),
    ...mapGetters('tour', ['currentTarget']),
    ...mapGetters('settings', ['PracticeTypes', 'PracticeTypesPlural']),
    _page() {
      return Math.min(this.pageCount, this.page) - 1
    },
    limit() {
      return this.activeTour ? 5 : 10
    },
    pageCount() {
      return Math.ceil(this.filteredOrResults.length / this.limit)
    },
    pagedResults() {
      let results = this.filteredOrResults.filter(
        (_, i) => i >= this._page * this.limit && i < this._page * this.limit + this.limit
      )

      return results
    },
    numSuggestionsVisible() {
      if (this.searchTab != null || this.isMyNetworkOnly) return 0
      return 99
    },
    filterZip() {
      let zip = this.user.practice.zip
      return zip && zip.length > 2 ? zip.substr(0, 2) + '*' : null
    },
    isNearbyAvailable() {
      return this.withNetwork
        .filter((s) => s.isSuggested)
        .filter((s) => !this.specialtyTab || s.specialty == this.specialtyTab).length
    },
    otherSpecialities() {
      return this.PracticeTypes.map((s, i) => i).filter((s) => s != this.user.practice.specialty)
    },
    suggestedSpecialties() {
      return this.isMyNetworkOnly || 1 == 1 //todo: remove this, as we will always use this logic for suggested unless all
        ? [0, 4, 5].includes(this.user.practice.specialty)
          ? [1, 3, 6] //if a gp, ped or orth show endo, oms, peri
          : [0, 3, 6]
        : this.otherSpecialities
    },
    highlightSuggested() {
      const suggested = this.withNetwork.filter((s) => s.isSuggested)
      return this.suggestedSpecialties.map((o) => suggested.filter((s) => s.specialty == o)?.[0]).filter((s) => s)
    },
    filteredOrResults() {
      let results = this.results
      results = results.sort(this.sorter) //pretty crytpic - but this sort is for the search tab
      if (this.searchTab == null) {
        const isBySpecialty = this.specialtyTab != null
        const emptySpecialties = this.specialtyList.filter((s) => s.count === 0).map((s) => s.i)
        // else if (this.specialtyTab == null) return this.filteredNetwork
        results = this.withNetwork
          .filter((s) => this.isMyNetworkOnly == !s.isSuggested)
          .filter(
            (s) =>
              (!isBySpecialty || s.specialty == this.specialtyTab) &&
              (!s.isSuggested || this.numSuggestionsVisible) &&
              (!s.isSuggested ||
                isBySpecialty ||
                // emptySpecialties.includes(s.specialty)
                this.suggestedSpecialties.includes(s.specialty))
          )

        //if all, let's zip the results
        if (!this.isMyNetworkOnly && !isBySpecialty) {
          var suggested = this.withNetwork.filter((s) => s.isSuggested)
          //todo: optimize this should be O(N+1)
          var specialties = this.suggestedSpecialties.concat(this.PracticeTypes.map((s, i) => i))

          var bySpecialty = specialties.map((o) => suggested.filter((s) => s.specialty == o))
          var maxLength = Math.max(...bySpecialty.map((s) => s.length))
          var zippedResults = []
          for (var k = 0; k < maxLength; k++)
            for (var i = 0; i < specialties.length; i++) {
              if (k < bySpecialty[i].length && !zippedResults.includes(bySpecialty[i][k]))
                zippedResults.push(bySpecialty[i][k])
            }

          return zippedResults
        }
        // if (
        //   this.numSuggestionsVisible > 0 &&
        //   this.suggested &&
        //   this.suggested.length
        // ) {
        //   //  &&          this.suggested[this.specialtyTab].length > 0;
        //   const emptySpecialties = this.specialtyList
        //     .filter((s) => s.count === 0)
        //     .map((s) => s.i)
        //   let suggested = isBySpecialty
        //     ? this.suggested[this.specialtyTab]
        //     : this.suggested.filter((s, i) => emptySpecialties.includes(i))
        //   results = [
        //     ...results.map((s) => ({
        //       ...s,
        //     })),
        //     ...(suggested || [])
        //       .map((bySpecialty) =>
        //         isBySpecialty ? bySpecialty : bySpecialty && bySpecialty[0]
        //       )
        //       .filter((s, i) => s && i < this.numSuggestionsVisible)
        //       .map((s) => ({ ...s, isSuggested: true })),
        //   ]
        // }
      }
      return results.sort(this.sorter)
      // [...new Map(results.map((s) => [s['id'], s])).values()] //monkey fix to prevent recent added to appear in suggestions too
    },
    specialtyList() {
      return this.PracticeTypes.map((name, i) => {
        const bySpecialty = this.network.filter((s) => s.specialty === i)
        return { i, name, items: bySpecialty, count: bySpecialty.length }
      })
    },
    isTourFixAppliedToTable() {
      return this.currentTarget == '[data-v-tour="networkResults"]'
    },
    selectedSpecialty() {
      return this.specialtyTab == null ? null : this.PracticeTypes[this.specialtyTab]
    },
  },
  async created() {
    if (!this.$store.state.practices.isLoaded && !this.$store.state.practices.isLoading) {
      await this.$store.dispatch('practices/load')
    }
    //todo: created isnt great for this, if you recently add one, this would not switch it
    this.isMyNetworkOnly = !this.activeTour
    // || (!this.activeTour && this.network.some((s) => s.network_behaviour === 1)) //we're default to true now regardless
    if (!this.$store.state.suggested.isLoaded && !this.$store.state.suggested.isLoading) {
      await this.$store.dispatch('suggested/load', { miles: this.miles })
    }
    if (!this.activeTour) this.isMyNetworkOnly = !!this.network.length || !this.isNearbyAvailable
  },
  watch: {
    miles(n, o) {
      if (n === o) return
      this.search()
      this.$store.dispatch('suggested/reset')
      this.$store.dispatch('suggested/load', { miles: this.miles })
    },
  },
  methods: {
    search() {
      if (!this.term || this.term.length < 3) return
      if (this.searchTimeout) clearTimeout(this.searchTimeout)
      this.isError = false
      this.showSearch()
      this.searchTimeout = setTimeout(async () => {
        this.isInitialHelpShown = false
        this.isSearching = true
        try {
          this.results = (await NpiService.search(this.term, null, null, this.miles)) || []
          this.searchResultsCount = this.results.length
          this.page = 1
          this.searchedTerm = this.term

          this.$track('$searchPracticeComplete', {
            term: this.term,
            count: this.results.length,
          })
        } catch (err) {
          //todo: handle errors
          this.isError = true
          this.$exception(err)
        }
        this.isSearching = false
        this.isEmpty = this.results.length === 0
      }, 300)
    },
    changePage(i) {
      this.page = i
    },
    filterSpecialty(s) {
      const value = this.specialtyTab === s ? null : s
      this.specialtyTab = value
      this.searchTab = null
      this.page = 1
      this.$store.dispatch('tour/specialtySelected', s)
      // this.isMyNetworkOnly = !this.activeTour
      // value == null ||
      // this.network.some((p) => p.network_behaviour === 1 && p.specialty == s)
    },
    searchNetwork() {
      this.$track('$searchPractice', { term: this.networkTerm })
      if (!this.networkTerm || this.networkTerm.length < 3) return

      this.term = this.networkTerm

      var numbers = this.networkTerm.replace(/\D/g, '')
      if (numbers.length == 10) this.term = numbers //todo: display formatted output on no results and input

      this.search()
    },
    showSearch(i) {
      this.page = 1
      this.sort = 'Distance'
      this.searchTab = true
      this.specialtyTab = null
      this.isMyNetworkOnly = false
    },
    sorter(a, b) {
      const cmp = (a, b) => (a > b) - (a < b)
      if (a.is_example != b.is_example) return a.is_example ? -1 : 0
      if (a.isSuggested != b.isSuggested) return !b.isSuggested ? 1 : 0
      if (a.isSuggested && a.status != b.status) return b.status != 0 ? 1 : -1
      if (this.sort == 'Name') {
        return (a.name || '').localeCompare(b.name)
      }
      if (this.sort == 'Distance') {
        return a.distance - b.distance
      }
      if (this.sort == 'Last referral sent') {
        return b.last_referral_timestamp - a.last_referral_timestamp
      }
    },
    manuallySelected(practice) {
      this.selectedPractice({ practice })
    },
    async selectedPractice({ practice, isAddedToNetwork }) {
      this.$emit('selected', practice)
      if (!this.redirect) return
      this.$router.push(
        practice.is_example ? '/referral/example-referral' : `/${this.redirect}?to=${practice.id}`,
        () => this.addSelectionToNetwork({ practice, isAddedToNetwork })
      )
    },
    async addSelectionToNetwork({ practice, isAddedToNetwork }) {
      if (isAddedToNetwork) {
        this.$store.commit('practices/savePractice', {
          ...practice,
          isSuggested: false,
        })
        this.$store.dispatch('suggested/removeById', practice.id)
      }
    },
  },
}
</script>
<style lang="scss">
.pick-referring-office {
  table {
    border-collapse: separate;
  }
  table.table-hover tbody tr:not(.invite-visible):hover {
    background-color: rgba(var(--info-color), 0.15);
    opacity: 1 !important;
    /* cursor: pointer; */
  }
  table.table-hover tbody tr.expanded-row {
    opacity: 1 !important;
    /* cursor: pointer; */
  }
  table.table-hover tbody tr {
    cursor: default;
  }

  table.table-hover tbody tr .show-on-hover {
    display: none;
  }

  table.table-hover tbody tr:not(.invite-visible):hover .show-on-hover {
    display: block;
  }
  table.table-hover tbody tr:not(.invite-visible):hover .mute-on-hover {
    opacity: 0.1;
  }

  table.table-hover tbody tr.hover-none:hover {
    background: unset;
    cursor: default;
  }

  .overlay-row {
    position: absolute;
    width: 100%;
    text-align: center;
    height: 100%;
    vertical-align: middle;
    display: flex;
    align-items: center;
  }

  .hover-pointer:hover {
    cursor: pointer;
  }

  a.list-item {
    display: block;
    padding: 0.85em 0.5em;
    border-top: 1px solid #f4f4f4;
    font-size: 0.75em;
    text-transform: uppercase;
    background: #f9f9f9;
  }
  a.list-item.active {
    border-left: 2px solid #1cacda;
    background: white;
  }
  a.list-item:not(.active):hover {
    background: #e4f5fb;
  }
  .table th,
  .table td {
    border-top: none;
    /* border-top: 1px solid #f1f1f1; */
    padding: 0;
  }
  .table .result-row td > div {
    transition: max-height 0.25s cubic-bezier(0.45, 0.05, 0.55, 0.95);
    max-height: 4em;
  }

  .result-row td > div .overlay-row {
    transition: opacity 0.35s cubic-bezier(0.22, 0.61, 0.36, 1);
    overflow: hidden;
    opacity: 0;
    max-height: 0;
  }
  .result-row.expanded-row td > div .overlay-row {
    max-height: 8em;
    overflow: visible;
    opacity: 1;
  }
  .result-row.expanded-row td > div .overlay-row + div {
    /* transition: opacity 0.25s ease-in; */
    overflow: hidden;
    opacity: 0;
  }
  tr.result-row td {
    /* padding: 1em 0; */
    border: 1px solid var(--border-color);
    border-radius: 5px;
  }
  .search-row {
    /* border: 1px solid #f3f3f3; */
    background: var(--light-color);
    border-radius: 5px;
    padding: 2.5rem;
  }

  .text-truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .expanded-row.result-row td {
    max-height: 8em;
    background: var(--primary-color-20);
    padding: 0.5em;
  }
  .expanded-row.result-row td > div {
    height: 8em;
    max-height: 8em;
  }

  .specialty-card {
    background: #ffffff;
    border-radius: 10px;
    text-align: center;
    font-size: 1.25em;
    font-weight: bolder;
    color: var(--body-color);
    padding: 0.75rem 1rem;
    box-sizing: border-box;
    margin: 1px;
  }
  .specialty-card:hover {
    background: var(--light-color);
    /* border: 1px solid var(--primary-color) !important; */
  }
  .specialty-card.active {
    margin: 0px;
    border: 2px solid var(--primary-color) !important;
    background: var(--primary-color-20);
  }
  .search-item {
    background: #e8f6ff;
    padding: 0.5em 1.5em;
    border-radius: 10px;
    display: inline-flex;
  }

  tr {
    /* padding: 1em 0; */
  }
  tr td {
    background: white;
    border: none;
    padding: 1em 0.25em;
  }
  tr.suggested td {
    background: #ffffffba;
  }

  tbody.detail-active tr:not(.detail-row):not(.expanded) td {
    opacity: 0.5;
  }

  tr.spacer td {
    background: transparent;
    border: none;
    padding: 0.3em 0;
    pointer-events: none;
  }
  tr.spacer.small-spacer td {
    padding: 0.15em 0;
  }

  td,
  th {
    padding-left: 0.25em;
    padding-right: 0.25em;
  }
  tr:not(.spacer) td:first-child {
    padding: 1rem 2rem;
  }
  .rounded-white {
    border-radius: 10px;
    background: #fff;
  }
  .table tbody + tbody {
    border: none;
  }
  .btn-thick {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .search-input {
    border-bottom: 1px solid transparent;
  }
  .search-input:focus-within,
  .search-input.active {
    border-bottom: 1px solid var(--body-color);
  }
  .bottom-bar {
    background: #cbd9d9de;
    display: flex;
    padding: 1rem 2rem;
    padding-bottom: 0rem;
    position: fixed;
    left: 0;
    bottom: 0;
    // bottom: -70px;
    width: 100%;
    transition: background 0.5s ease-out;
    transition: bottom 0.5s ease-out;
    transition: max-height 0.5s ease-out;
    z-index: 7777;

    max-height: 150px;
    &:hover,
    &.searching {
      background: var(--border-color);
      bottom: 0;
    }

    &.searching {
      max-height: 620px;
    }
  }
}
@media (min-width: 576px) {
  a.list-item {
    padding: 0.5em;
    font-size: 0.75em;
  }
}

@media (min-width: 962px) {
  a.list-item {
    padding: 1em;
    font-size: 1em;
  }
}
.modal-header {
  padding: 0 0 0.5rem 0;
}
.modal-header h3 {
  font-size: 1.2rem;
}

@media (min-width: 576px) {
  .modal-header {
    padding: 0 0 1rem 0;
  }
  .modal-header h3 {
    font-size: 1.4875rem;
  }
}

.specialty-select .btn-link {
  padding: 0.25rem 0.5rem;
  border-radius: 0;
  color: var(--body-color);
  margin-right: 0.5rem;
  &.active {
    color: var(--primary-color);
    border-bottom: 1px solid var(--primary-color);
    font-weight: bolder;
  }
}
</style>
